module.exports = __webpack_public_path__ + "static/iid-share-6d019a0c3c7309a8edb5d128d9fe3924.png";